import analytics from '../index';

let currentMaxDepth = 0;

async function trackMaxScrollDepth(formID) {
  const maxDepthPayload = {
    form_id:   formID,
    max_depth: currentMaxDepth,
  };

  await analytics.track('maxDepth', maxDepthPayload);
  currentMaxDepth = 0;
}

function handleScrollEvent() {
  if (window.scrollY > currentMaxDepth) {
    currentMaxDepth = window.scrollY;
  }
}

function addScrollEventListeners() {
  document.addEventListener('scroll', handleScrollEvent);
}

function removeScrollEventListeners() {
  document.removeEventListener('scroll', handleScrollEvent);
}

export {
  addScrollEventListeners,
  removeScrollEventListeners,
  handleScrollEvent,
  trackMaxScrollDepth,
};
